<template>
	<div class="content">
		<h3>数码替换</h3>
		<div class="item">
			<el-form ref="form" inline  :model="form" label-width="100px">
                <el-form-item label="请输入旧码">
					<el-input v-model="form.factoryName"></el-input>
				</el-form-item>
                <el-form-item label="请输入新码">
					<el-input v-model="form.factoryName"></el-input>
				</el-form-item>
			</el-form>
			<div class="btn">
				<el-button type="primary"  @click="SelFactory">确 定</el-button>
				<el-button type="primary" @click="SelFactory">批量替换</el-button>
			</div>
		</div>
	</div>
</template>

<script>
import {validateNumber} from '../utils/rules'
export default {
	data(){
		return {
			tableData: [],
			form:{

            },
			rules: {
        		factoryName:[
          			{ required: true, message: '请输入一个工厂名称', trigger: 'change' }
        		],
			},
			pageNum:0,
		}
	},
	methods: {
		close(){
			this.$refs['form'].resetFields()
		},
		restForm(){
			this.$nextTick(()=>{
				this.$refs['form'].resetFields()
			})
        },
        handleCurrentChange(){

        }
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:0 100px;
}
.el-input,.el-select{
	width:220px;
}
</style>


// WEBPACK FOOTER //
// src/pages/CodeReplace.vue